import { ConnectedApplicationErrorCode } from '~commonInfra/utils/ErrorCodes';
import { ContentUrlForItem } from '~src/spacesPlatform/services/ContentUrl';

import { Messages } from '../../codegen/Localize';
import { IErrorDetail } from '../../commonInfra/contentActions/ActionMessages';
import { IErrorItem } from '../../commonInfra/contentActions/MultipleItemResult';
import { ConnectedApplicationContentType } from '../models/ConnectedApplicationContentType';
import { IConnectedApplicationInfo } from '../models/ConnectedApplicationInfo';

export namespace ConnectedApplicationErrors {

    export function getErrorDetailsForConnectedApp(connectedAppsErrorItem: IErrorItem<IConnectedApplicationInfo>): IErrorDetail {
        return {
          itemName: connectedAppsErrorItem.item.name,
          itemUrl:
          // eslint-disable-next-line eqeqeq
          connectedAppsErrorItem.error.code == ConnectedApplicationErrorCode.CONNECTED_APP_NOT_FOUND
              ? null
              : ContentUrlForItem(connectedAppsErrorItem.item, ConnectedApplicationContentType),
          errorMessage: this.getErrorMessageForConnectedApp(connectedAppsErrorItem)
        };
    }

    export function getErrorMessageForConnectedApp(errorItem: IErrorItem<IConnectedApplicationInfo>) {
        const connectedApp = errorItem.item;
        switch (Number(errorItem.error.code)) {
            case ConnectedApplicationErrorCode.CONNECTED_APP_NOT_FOUND:
                return Messages.errorConnectedApplicationNotFound({CA_NAME: connectedApp.name});

            default:
                return Messages.errorUnknown();
        }
    }
}